import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { type DrillAsset, useDrillAssets } from "../../api/useDrillAssets";
import type { DrillOption } from "../../model/Drill";
import { TIER_COST } from "../../model/TIER_COST";
import { formatNumber } from "../../model/formatNumber";

export type OptionView = {
  name: string;
  // Подпись под названием: цена и ветка предмета, «Способность», «Пули».
  note: string | null;
  asset: DrillAsset | null;
};

const ITEM_NOTE = msg({ message: "{cost} souls · {slot}" });

// Вариант ответа или источник урона для показа: что это (предмет, способность, герой, оружие,
// ближний бой), название, иконка и подпись.
export const useOptionView = (): ((option: DrillOption) => OptionView) => {
  const { i18n, t } = useLingui();
  const assets = useDrillAssets();
  const slotNames = { weapon: t`weapon`, vitality: t`vitality`, spirit: t`spirit` } as const;
  return (option) => {
    if (option.item_id != null) {
      const asset = assets.item(option.item_id);
      const cost = asset.tier === null ? undefined : TIER_COST[asset.tier];
      const note =
        cost === undefined || asset.slot === null
          ? null
          : i18n._({
              ...ITEM_NOTE,
              values: { cost: formatNumber(cost, i18n.locale), slot: slotNames[asset.slot] },
            });
      return { name: asset.name, note, asset };
    }
    if (option.ability_id != null) {
      return {
        name: assets.ability(option.ability_id).name,
        note: t`Ability`,
        asset: assets.ability(option.ability_id),
      };
    }
    if (option.hero_id != null) {
      return {
        name: assets.hero(option.hero_id).name,
        note: null,
        asset: assets.hero(option.hero_id),
      };
    }
    if (option.damage_source === "weapon") {
      return { name: t`Weapon`, note: t`Bullets`, asset: null };
    }
    if (option.damage_source === "melee") {
      return { name: t`Melee`, note: t`Light and heavy melee`, asset: null };
    }
    return { name: option.id, note: null, asset: null };
  };
};
